export function formatDate(dateInput: number, locale?: string) {
    const date = new Date(dateInput)
    const now = new Date()

    // A missing or bad timestamp would make Intl throw ("Invalid time value") and take the page down.
    if (dateInput === undefined || dateInput === null || isNaN(date.getTime()))
        return "—"

    const currentLocale =
        locale ||
        navigator.languages?.[0] ||
        navigator.language ||
        "en-US"

    const isSameDay = (a: Date, b: Date) =>
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()

    const yesterday = new Date(now)
    yesterday.setDate(now.getDate() - 1)

    const time = new Intl.DateTimeFormat(currentLocale, {
        hour: "numeric",
        minute: "2-digit",
    }).format(date)

    const rtf = new Intl.RelativeTimeFormat(currentLocale, {
        numeric: "auto",
    })

    if (isSameDay(date, now)) {
        return `${rtf.format(0, "day")} • ${time}`
    }

    if (isSameDay(date, yesterday)) {
        return `${rtf.format(-1, "day")} • ${time}`
    }

    return new Intl.DateTimeFormat(currentLocale, {
        day: "numeric",
        month: "long",
        year:
            date.getFullYear() !== now.getFullYear()
                ? "numeric"
                : undefined,
        hour: "numeric",
        minute: "2-digit",
    }).format(date)
}